<template>
  <v-row>
    <v-col cols="1" class="numero">{{ numero }}</v-col>
    <v-col
      v-if="!valeurSeule"
      :cols="titreSeul ? 11 : 5"
      :md="titreSeul ? 11 : 4"
      :lg="titreSeul ? 11 : 3"
      class="intitule"
    >
      <span v-if="intitule">{{ intitule }} :</span>
      <slot name="intitule"></slot>
    </v-col>
    <v-col
      v-if="!titreSeul"
      :cols="valeurSeule ? 11 : 6"
      :md="valeurSeule ? 11 : 7"
      :lg="valeurSeule ? 11 : 8"
      class="valeur"
    >
      <slot></slot>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    numero: {
      type: String,
      required: false,
    },
    intitule: {
      type: String,
      default: "",
    },
    titreSeul: {
      type: Boolean,
      default: false,
    },
    valeurSeule: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.numero {
  background-color: var(--v-produitdarken1-base);
  color: white;
  font-weight: bold;
}
.intitule {
  background-color: var(--v-produitlighten5-darken1);
  color: var(--v-produit-base);
  font-weight: bold;
}

.valeur {
  background-color: var(--v-produitlighten5-base);
}
</style>
